$(document).ready(function () {
  // Banner slider
  $('.bannerslider-section').slick({
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<div class="arrowsec prev-arrowsec"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
    nextArrow: '<div class="arrowsec next-arrowsec"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>'
  });

  // Featured collection slider
$('.feature-collectionmain ul').each(function () {
  var $slider = $(this);
  var totalSlides = $slider.children('li').length;
  var desktopSlides = Math.min(totalSlides, 4);
  $slider.slick({
    dots: false,
    infinite: false,
    slidesToShow: desktopSlides,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(totalSlides, 1.4),
          slidesToScroll: 1
        }
      }
    ]
  });
});

 
var slider = new Swiper ('.large-image', {
  spaceBetween: 0,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
      loopedSlides: 3,
    },
    768: {
      slidesPerView: 1,
      loopedSlides: 6,
    }
  }
});
var thumbs = new Swiper ('.small-image', {
  spaceBetween: 50,
  slidesPerView: 3,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  centeredSlides: true,
  loop: true,
  slideToClickedSlide: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    300: {
      slidesPerView: 2,
       spaceBetween: 20,
    },
    768: {
      slidesPerView: 3
    }
  }
});
slider.controller.control = thumbs;
thumbs.controller.control = slider; 


 var swiper = new Swiper(".daily-plan", {
    spaceBetween: 10,
    slidesPerView: 5,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    loop:true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      300: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 6,
      }
    }
  })

  
});
